<template>
      <div class="index container">

        <transition name="fade">
          <router-view @showParent="showParent">
          </router-view>
        </transition>
        
        <div v-if="showParentPage">
          <v-breadcrumbs>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
              >Home</v-breadcrumbs-item
            >
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item
              :exact="true"
              :to="{ name: 'pageParameters', params: {} }"
              active
            >
              Page Parameters
            </v-breadcrumbs-item>
          </v-breadcrumbs>

        <div class="d-flex flex-column flex-lg-row">
          <v-text-field
            dense
            v-model="searchTerms"
            @keyup.enter="search"
            @click:clear="search"
            @click:append="search"
            placeholder="Press enter to begin search"
            append-icon="mdi-magnify"
            outlined
            clearable
            label="Search"
          />
          <v-btn
            class="ml-0 ml-lg-4 mb-2 mb-lg-0 align-self-end align-self-lg-start"
            color="primary"
            :to="{ name: 'pageParametersCreate', params: {} }"
          >
            Create Page Parameters
          </v-btn>
        </div>

        <div class="table-container">
          <v-data-table
            :headers="headers"
            :items="pageParametersList"
            :items-per-page="pagination.pageSize"
            :loading="!pageParametersProcessed"
            :server-items-length="pagination.totalSize"
            :page="pagination.current"
            :disable-sort="true"
            item-key="id"
            class="elevation-1"
            @update:options="pageChanged"
          >
            
            <template v-slot:item.owner_only="{ item }">
              <a @click="view(item)">{{ item.owner_only }}</a>
            </template>
            
            <template v-slot:item.created_by="{ item }">
              <a @click="view(item)">{{ item.created_by }}</a>
            </template>
            
            <template v-slot:item.create_time="{ item }">
              <a @click="view(item)">{{ item.create_time }}</a>
            </template>
            
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="edit(item)">
                mdi-pencil
              </v-icon>
              <v-icon small class="mr-2" @click="remove(item)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </div>
      </div>
      <confirmation-dialog ref="confirm" />
    </div>
  </template>

    <script>
    import { mapActions, mapGetters } from "vuex";
  
    export default {
      data(){
        return {
          pagination: {
            current: 1,
            pageSize: 10,
            totalSize: 100
          },
          pageParametersList: [],
          showParentPage: true,
          
      headers: [
        {
          text: "Name",
          value: "name",
          align: "start",
          sortable: true
        },
        {
          text: "Page Name",
          value: "page_name",
          align: "start",
          sortable: true
        },
        {
          text: "Vuex Name",
          value: "vuex_name",
          align: "start",
          sortable: true
        },
        {
          text: "Owner Only",
          value: "owner_only",
          align: "start",
          sortable: false
        },
        {
          text: "undefined",
          value: "created_by",
          align: "start",
          sortable: false
        },
        {
          text: "Created on",
          value: "create_time",
          align: "start",
          sortable: false
        },
        
        { text: "Actions", value: "actions", align: "end", sortable: false }
      ],
          sort: {
            key: null
          },
          searchTerms : ''
        }
      },
      computed: {
        ...mapGetters("pageParameters", ["pageParametersProcessed", "getPageParameters"]),
      },
      methods: {
        ...mapActions("messages", [
          "addErrorMessage",
          "addMessage",
          "addSuccessMessage"
        ]),
        ...mapActions("pageParameters", ["deletePageParameters", "fetchPageParameters"]),
        view(item){
          this.$router.push({ name: 'pageParametersView', params: { id: item.id }})
        },
        edit(item){
          this.$router.push({ name: "pageParametersEdit", params: { id: item.id }})
        },
        async remove(item){
          let confirm = await this.$refs.confirm.open(
            "Confirm Delete",
            "Do you want to delete this pageParameters?"
          );
          if(confirm){
            this.deletePageParameters(item.id)
              .then( () => {
                this.addSuccessMessage("pageParameters was deleted successfully");
                this.getResources();
              }).catch( () => {
                this.addErrorMessage("Server response with error ");
              });
          }
        },
        getResources() {
          const params = {
            page: this.pagination.pageIndex && this.pagination.pageIndex > 0 ? this.pagination.pageIndex-1:0,
            size: this.pagination.pageSize,
          };
          this.fetchPageParameters(params)
            .then(response => {
              if(response){
                this.pagination.totalSize = response.totalElements;
                this.pageParametersList = response.content;
              }
            })
            .catch(error => {
              this.addErrorMessage("Server response with error " + error);
            });
        },
        showParent(show) {
          this.showParentPage = show;
        },
        pageChanged(pagination) {
          this.pagination.pageIndex = pagination.page;
          this.pagination.pageSize = pagination.itemsPerPage;

          this.getResources()
        },
        search(){
          this.getResources();
        }
      },
      watch: {
        'pagination.numberRegisterForPage': function(){
            this.pagination.current = -1;
        },
      },
      beforeRouteUpdate(to, from, next) {
        const toDepth = to.path.split("/").length;
        const fromDepth = from.path.split("/").length;
        this.showParentPage = toDepth < fromDepth;
        if (this.showParentPage) {
          this.getResources();
        }
        next();
      }
    }
    </script>

    